import { FC } from "react";

import { TransferCaseNotNowProps } from "./types";



const TransferNotNowModal: FC<TransferCaseNotNowProps> = ({ isModalVisible, hideModal }): JSX.Element => {
  return (
    <div
      className={`modal fade ${isModalVisible ? 'show show-modal' : ''}`}
      id="transferNotNowModal"
      tabIndex={-1}
      data-bs-backdrop="true"
      aria-hidden="true"
      onClick={hideModal}
    >
      <div className="modal-dialog modal-lg" onClick={e => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <p className="modal-title fw-bold" style={{color:'#008853', fontSize:'1.875rem'}}>
              Note:
            </p>
          </div>

          <div className="modal-body">
            <p className="h2">
              This case will NOT be transferred to Centerwell until clinical documents 
              to support PA process are uploaded
            </p>

            <div className="d-flex flex-fill justify-content-center">
              <button type="button" onClick={hideModal} className="btn btn-green">
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TransferNotNowModal
